import React, { useEffect, useState } from "react";
import { useLoader } from "../../context/LoaderContext";
import {
  IBannerData,
  IConsentLetters,
  ISurgicalData,
} from "../../exports/interfaces";
import { dynamicFailed } from "../../hooks/useToast";
import SurgicalDomainsBanner from "../../components/surgicaldomains/SurgicalDomainsBanner";
import SurgicalDomainsDescription from "../../components/surgicaldomains/SurgicalDomainsDescription";
import {
  fetchConsentLetters,
  fetchSkinPeels,
  fetchSkinPeelsBanner,
} from "../../api/SurgicalDomainApi";

const SkinPeels = () => {
  const { setLoading } = useLoader();
  const [skinPeelsBanner, setSkinPeelsBanner] = useState<IBannerData[]>([]);
  const [skinPeelsData, setSkinPeelsData] = useState<ISurgicalData[]>([]);
  const [consentLetters, setConsentLetters] = useState<IConsentLetters[]>([]);

  useEffect(() => {
    setLoading(true);
    // Promise.all([fetchArchiveBanner(), fetchVideoData()])
    Promise.all([
      fetchSkinPeelsBanner(),
      fetchSkinPeels(),
      fetchConsentLetters(),
    ])
      .then(([skinPeelsBannerData, skinPeelsData, consentLettersData]) => {
        setSkinPeelsBanner(skinPeelsBannerData);
        setSkinPeelsData(skinPeelsData);
        setConsentLetters(consentLettersData);
        // setArchiveVideoData(videoData);
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      })
      .catch(() => {
        setTimeout(() => {
          setLoading(false);
        }, 1000);
        dynamicFailed("Server Error");
      });
  }, [setLoading]);
  return (
    <>
      <SurgicalDomainsBanner bannerData={skinPeelsBanner} page={"Skin Peels"} />
      <SurgicalDomainsDescription descriptionData={skinPeelsData} consentLetters={consentLetters} surgicalName='Skin_Peels'/>
    </>
  );
};

export default SkinPeels;
